<nav
  aria-label="Chapters"
  role="navigation"
  class="view-chapters"
  [hidden]="(chapters$ | async)?.length === 1"
  #chapterList
  gaCategory="View Chapter List">
  <ol>
    <li 
      gaEvent 
      gaAction="Clicked Chapter"
      [gaLabel]="'Chapter ' + (i + 1) + ' of ' + (chapters$ | async)?.length"
      role="button"
      [attr.aria-label]="chapter.info.displayName"
      class="view-chapters__item"
      *ngFor="let chapter of (chapters$ | async); let i = index;"
      [attr.data-chapter-id]="(chapter.id | elementID)"
      (click)="handleChapterClick(chapter)"
      (keyup.enter)="handleChapterClick(chapter)"
      [ngClass]="{
        'view-chapters__item--viewed': isViewed(chapter.id),
        'view-chapters__item--selected': chapter.id === (selectedChapterId$ | async)
      }"
      tabindex="0">
      
      <div class="view-chapters__index">{{ i + 1 }}.</div>
      <div class="view-chapters__title">{{ chapter.info.displayName }}</div>
      <div class="view-chapters__thumb" [defaultImage]="defaultImage" [lazyLoad]="getChapterThumb(chapter.id)"></div>
    </li>
  </ol>
</nav>
